<template>
  <div class="position-detail-feature-point">
    <template v-if="activeFeature">
      <div class="visible-sm">
        <div
          class="position-detail-feature-point__top"
          :style="{
            'background-color': activePosition.gemeente.app_asset
              ? activePosition.gemeente.app_asset.color_primary
              : null
          }"
        >
          <div class="position-detail-feature-point__top__left">
            <svg svg-inline="" @click="unsetActiveFeature" class="position-detail-feature-point__top__left__icon" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#101010" mask="url(#b)" d="M16 4.462L14.603 3 6 12l8.603 9L16 19.538 8.795 12z"/></g></svg>
            <div class="position-detail-feature-point__top__left__text">
              Terug
            </div>
          </div>
        </div>
      </div>
      <FeaturePointMaps
        :activeFeature="activeFeature"
        :activePosition="activePosition"
      />
      <div class="position-detail-feature-point__bottom">
        <img
          :src="imageUrl(activeFeature.properties.category_id)"
          class="position-detail-feature-point__bottom__icon"
        />
        <div class="position-detail-feature-point__bottom__title">
          {{ activeFeature.properties.name }}
        </div>
        <div class="position-detail-feature-point__bottom__subtitle">
          {{ $dayjs(activeFeature.properties.published_at).format("LL") }} -
          {{ getCategoryString(activeFeature.properties.category_id) }}
        </div>
        <div class="position-detail-feature-point__bottom__subtitle">
          {{ activeFeature.properties.distance }}m
        </div>
        <div class="position-detail-feature-point__bottom__icon-bar">
          <template
            v-if="
              !viewPositionDetailIndexDeleted &&
                !isDeleted &&
                activeFeature.geometry.type != 'Polygon'
            "
          >
            <div @click="starFeature">
              <template v-if="isStarred">
                <svg svg-inline="" class="position-detail-feature-point__bottom__icon-bar__icon-star" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#FFCD00" mask="url(#b)" d="M11.868 17.07l6.1 3.68-1.62-6.938 5.389-4.667-7.096-.602L11.868 2 9.095 8.543 2 9.145l5.388 4.668L5.77 20.75z"/></g></svg>
              </template>
              <template v-else>
                <svg svg-inline="" class="position-detail-feature-point__bottom__icon-bar__icon-star" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z" fill="#9B9B9B" mask="url(#b)"/></g></svg>
              </template>
            </div>
          </template>
          <template
            v-if="
              !viewPositionDetailIndexStarred &&
                !isStarred &&
                activeFeature.geometry.type != 'Polygon'
            "
          >
            <div @click="deleteFeature">
              <template v-if="isDeleted">
                <svg svg-inline="" class="position-detail-feature-point__bottom__icon-bar__icon-delete" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" fill="#101010" mask="url(#b)"/></g></svg>
              </template>
              <template v-else>
                <svg svg-inline="" class="position-detail-feature-point__bottom__icon-bar__icon-delete" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4h-3.5z" fill="#9B9B9B" mask="url(#b)"/></g></svg>
              </template>
            </div>
          </template>
          <template v-if="shareUrl">
            <div v-if="shareAble">
              <svg @click="shareFeature(activeFeature)" svg-inline="" class="position-detail-feature-point__bottom__icon-bar__icon-share" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7 0-.24-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92 0-1.61-1.31-2.92-2.92-2.92zM18 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM6 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm12 7.02c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" fill="#9B9B9B" mask="url(#b)"/></g></svg>
            </div>
          </template>
        </div>
        <template v-if="featureDetails">
          <div class="position-detail-feature-point__bottom__main-content">
            <div
              v-for="field in featureDetails.fields"
              :key="field"
              class="position-detail-feature-point__bottom__main-content__field"
            >
              <div
                class="position-detail-feature-point__bottom__main-content__field__p"
              >
                <div v-html="field"></div>
              </div>
            </div>
          </div>
          <div class="position-detail-feature-point__bottom__buttons-under">
            <a
              :href="externalUrl"
              target="_blank"
              class="position-detail-feature-point__bottom__buttons-under__button"
              >Meer informatie</a
            >
            <button
              @click="openModalReport"
              class="position-detail-feature-point__bottom__buttons-under__button"
            >
              Meld fout
            </button>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import PrivateApi from "@/services/PrivateApi.js";
import LoadOrReturnCategories from "@/services/LoadOrReturnCategories.js";
import FeaturePointMaps from "@/components/Position/FeaturePointMaps";
import CategoryIdToString from "@/services/CategoryIdToString";

export default {
  components: {
    FeaturePointMaps
  },
  data() {
    let shareAble = navigator.share;

    return {
      loadedCategories: null,
      featureDetails: null,
      externalUrl: null,
      shareUrl: null,
      reportId: null,
      shareAble: shareAble
    };
  },
  mounted() {
    let self = this;

    LoadOrReturnCategories().then(function(categories) {
      self.loadedCategories = categories;
    });
    if (this.activeFeature) {
      this.getActiveFeature();
    }
  },
  computed: {
    activeFeature() {
      return this.$store.state.ui.activeFeature;
    },
    activePosition() {
      return this.$store.state.ui.activePosition;
    },
    starredFeatures() {
      return this.$store.state.ui.starredFeatures;
    },
    starredFeaturesLength() {
      return this.starredFeatures.length;
    },
    deletedFeatures() {
      return this.$store.state.ui.deletedFeatures;
    },
    deletedFeaturesLength() {
      return this.deletedFeatures.length;
    },
    pointFeatures() {
      return this.$store.state.ui.pointFeatures;
    },
    isDeleted() {
      if (this.activeFeature) {
        var deletedFeatures = this.deletedFeatures;
        var index = deletedFeatures.findIndex(
          x => x.properties.id == this.activeFeature.properties.id
        );
        return index != -1;
      } else {
        return false;
      }
    },
    isStarred() {
      if (this.activeFeature) {
        // var starredFeatures = this.starredFeatures.filter(x => x.positionId == this.activePosition.properties.id);
        var starredFeatures = this.starredFeatures;
        var index = starredFeatures.findIndex(
          x => x.properties.id == this.activeFeature.properties.id
        );
        return index != -1;
      } else {
        return false;
      }
    },
    viewPositionDetailIndexDeleted() {
      return this.$store.state.ui.sidebarPositionDetailIndexDeleted;
    },
    viewPositionDetailIndexStarred() {
      return this.$store.state.ui.sidebarPositionDetailIndexStarred;
    }
  },
  watch: {
    activeFeature() {
      if (this.activeFeature) {
        this.getActiveFeature();
      }
    }
  },
  methods: {
    getActiveFeature() {
      let self = this;
      PrivateApi()
        .get(
          `positions/${this.activePosition.id}/features/${
            this.activeFeature.properties.id
          }`
        )
        .then(function(feature) {
          self.reportId = feature.data.buttons.find(
            x => x.type == "report"
          ).value;
          self.externalUrl = feature.data.buttons.find(
            x => x.type == "url"
          ).value;
          self.shareUrl = feature.data["share"]["share_url"];
          var featureDetails = feature.data;
          var featureDetailsFields = featureDetails.fields.map(x =>
            x.value.replace(/\\n/g, "<br />")
          );
          featureDetails.fields = featureDetailsFields;
          self.featureDetails = featureDetails;
        });
    },
    getCategory(categoryId) {
      if (this.loadedCategories) {
        return this.loadedCategories.data.find(x => x.id == categoryId);
      }
    },
    getCategoryString(category_id) {
      let string = CategoryIdToString(category_id);
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    unsetActiveFeature() {
      this.$store.commit("setActiveFeature", null);
    },
    starFeature() {
      var starredFeatures = this.starredFeatures;
      var index = starredFeatures.findIndex(
        x => x.properties.id == this.activeFeature.properties.id
      );
      let pointFeatures = this.pointFeatures;
      var pointFeaturesIndex = pointFeatures.findIndex(
        x => x.properties.id == this.activeFeature.properties.id
      );
      if (index != -1) {
        starredFeatures.splice(index, 1);
        this.$store.commit("setActiveFeature", null);
        if (this.starredFeaturesLength == 0) {
          this.$store.commit("closeSidebarPositionDetailIndexStarred");
          this.$store.commit("openSidebarPositionDetailIndex");
        }
      } else {
        pointFeatures.splice(pointFeaturesIndex, 1);
        starredFeatures.push(this.activeFeature);
      }
      this.$store.commit("setStarredFeatures", starredFeatures);
    },
    deleteFeature() {
      var deletedFeatures = this.deletedFeatures;
      var deleteFeaturesIndex = deletedFeatures.findIndex(
        x => x.properties.id == this.activeFeature.properties.id
      );
      let pointFeatures = this.pointFeatures;
      var pointFeaturesIndex = pointFeatures.findIndex(
        x => x.properties.id == this.activeFeature.properties.id
      );
      if (deleteFeaturesIndex != -1) {
        deletedFeatures.splice(deleteFeaturesIndex, 1);
        pointFeatures.push(this.activeFeature);
        this.$store.commit("setActiveFeature", null);
        if (this.deletedFeaturesLength == 0) {
          this.$store.commit("closeSidebarPositionDetailIndexDeleted");
          this.$store.commit("openSidebarPositionDetailIndex");
        }
      } else {
        deletedFeatures.push(this.activeFeature);
        pointFeatures.splice(pointFeaturesIndex, 1);
        this.$store.commit("setActiveFeature", null);
      }
      this.$store.commit("setDeletedFeatures", deletedFeatures);
    },
    shareFeature() {
      if (navigator.share) {
        navigator.share({
          title: "[OmgevingsAlert] Bekijk deze melding",
          url: this.shareUrl
        });
      }
    },
    imageUrl(categoryId) {
      if (this.loadedCategories) {
        return this.loadedCategories.data.find(x => x.id == categoryId)
          .icon_url;
      }
    },
    openModalReport() {
      this.$store.commit("openModalReport");
    }
  }
};
</script>

<style scoped lang="scss">
.position-detail-feature-point {
  // anders regelen... absolute positioning
  position: absolute;
  min-height: 100%;
  width: 100%;
  left: 0;
  background: #fff;
  z-index: 4000;

  &__top {
    height: 52px;
    display: flex;
    align-items: center;
    padding-left: $spacing-3;
    background: $color-green-1;

    &__left {
      display: flex;
      align-items: center;

      &__icon {
        display: inline-block;
        position: relative;
        top: 1px;
        cursor: pointer;
        left: -6px;

        path {
          fill: #fff;
        }
      }
      &__text {
        display: inline-block;
        @extend %text-large;
        color: #fff;
        padding: 0 $spacing-2 0 0;
      }
    }
  }

  &__bottom {
    flex: 1;
    overflow-y: auto;
    padding: $spacing-4 $spacing-3 $spacing-3;

    &__icon {
      display: inline-block;
      height: 56px;
      width: 56px;
    }

    &__title {
      @extend %text-title-2;
      margin-bottom: $spacing-3;
    }

    &__subtitle {
      @extend %text-mini;
      color: $color-black-3;
    }

    &__icon-bar {
      display: flex;
      align-items: center;
      margin-top: $spacing-3;

      div {
        cursor: pointer;
        &:not(:first-child) {
          margin-left: $spacing-3;
        }
      }
    }

    &__main-content {
      border-top: 1px solid $color-gray-1;
      margin-top: $spacing-4;
      padding: $spacing-4 0;

      &__field {
        &:not(:first-child) {
          margin-top: $spacing-3;
        }
        &__p {
          @extend %text-medium;
        }
      }
    }

    &__buttons-under {
      display: flex;
      flex-direction: column;
      align-items: center;

      &__button {
        &:not(:first-child) {
          margin-top: $spacing-3;
        }
        cursor: pointer;
        border: 0;
        height: 48px;
        border-radius: 6px;
        background: $color-gray-1;
        width: 100%;
        text-align: center;
        color: $color-black-1;
        line-height: 48px;
        @extend %text-medium;
      }
    }
  }
}

@media (min-width: 768px) {
  .position-detail-feature-point {
    width: calc(100% - 414px);
    right: 0;
    left: auto;
    z-index: 2500;

    .visible-sm {
      display: none;
    }

    &__bottom {
      padding: $spacing-6 $spacing-6;

      &__buttons-under {
        flex-direction: row;

        &__button {
          &:not(:first-child) {
            margin-top: 0;
            margin-left: $spacing-4;
          }
          padding: 0 $spacing-3;
          width: auto;
        }
      }
    }
  }
}
</style>
